<article>
	<header>
		<h3>
			{{ 'adminstat.common.withdrawals_recurrent' | translate }}
		</h3>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
		<hr/>
	</section>
	
	<section>
		<loading_percent [percent]="withdrawalsRecurrentPercentLoader"></loading_percent>
	</section>
	
	<section>
		<chart [data]="withdrawalsRecurrentByGateChart.data" [options]="withdrawalsRecurrentByGateChart.options"></chart>
	</section>

	<br/>
	
	<section>
		<loading [isLoad]="statsByGateLoader"></loading>
		
		<table class="table by_gate">
			<thead>
				<tr>
					<th *ngFor="let header of dataByGate.headers; let i = index" [colSpan]="header.colspan">
						<div [ngClass]="header.title === 'month' ? 'ul-table-date-container-small' : ''">
							{{ i18n[header.title] || header.title }}
						</div>
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let row of dataByGate.rows">
					<td *ngFor="let v of row; let i = index">
						<div *ngIf="i === 0; else noDate">
							{{ v | dateFormat }}
						</div>
						
						<ng-template #noDate>
							{{ v || '-' }}
						</ng-template>
					</td>
				</tr>
			</tbody>
		</table>
	</section>

	<hr/>

	<section>
		<chart [data]="withdrawalsRecurrentByTryChart.data" [options]="withdrawalsRecurrentByTryChart.options"></chart>
	</section>
	
	<br/>
	
	<section>
		<loading [isLoad]="statsByTryLoader"></loading>
		
		<table class="table by_try">
			<thead>
			<tr>
				<th *ngFor="let header of dataByTry.headers; let i = index" [colSpan]="header.colspan">
					<div [ngClass]="header.title === 'month' ? 'ul-table-date-container-small' : ''">
						{{ i18n[header.title] || header.title }}
					</div>
				</th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let row of dataByTry.rows">
				<td *ngFor="let v of row; let i = index">
					<div *ngIf="i === 0; else noDate">
						{{ v | dateFormat }}
					</div>

					<ng-template #noDate>
						{{ v || '-' }}
					</ng-template>
				</td>
			</tr>
			</tbody>
		</table>
	</section>
</article>
